import { App, Feature, Menu } from '@mairistem/module';
import { request } from '@mairistem/tools';
import React from 'react';
import Context from './components/common/Context/Context';
import Parametres from './components/parametres/Parametres';
import ElaborationBudget from './components/simulation/ElaborationBudget';
import StorageKey from './constants/common/storage';
import 'react-toastify/dist/ReactToastify.css';
import './AppSimulation.css';

const getIdentifiantSimulationFromUrl = () => {
	const { pathname } = window.location;
	// Diviser le chemin en segments
	const segments = pathname.split('/');
	// Récupérer le dernier segment
	const lastSegment = segments.pop() || segments.pop();
	// Pour gérer les barres obliques finales
	return lastSegment;
};

const renderBreadcrumb = (
	path,
	{ BreadcrumbContainer, BreadcrumbSection, BreadcrumbSeparator },
) => (
	<BreadcrumbContainer>
		<BreadcrumbSection key="domain">
			{path.domain.toLocaleUpperCase()}
		</BreadcrumbSection>
		<BreadcrumbSeparator />
		<BreadcrumbSection key="feature">{path.feature}</BreadcrumbSection>
	</BreadcrumbContainer>
);

const AppSimulation = () => {
	const identifiantSimulationRef = React.useRef(
		getIdentifiantSimulationFromUrl(),
	);

	const handleOnAuth = async () => {
		// Gestion de l'identifiantExercice
		const queryParams = new URLSearchParams(window.location.search);
		sessionStorage.setItem(
			StorageKey.IDENTIFIANT_EXERCICE,
			queryParams.get('identifiantExercice'),
		);
	};

	return (
		<App
			breadcrumbRenderer={renderBreadcrumb}
			code="HOL_SIMU"
			context={Context}
			group="finances"
			name="Elaboration du budget"
			request={request}
			onAuth={handleOnAuth}
			additionalProductCodesUpdate={['HOL_CPTA']}
		>
			<Menu icon="cog" name="Paramètres" path="/parametres">
				<Feature>
					<Feature.Content>
						<Parametres />
					</Feature.Content>
				</Feature>
			</Menu>
			<Menu
				icon="home"
				name="Elaboration du budget"
				path={`/budgets/${identifiantSimulationRef.current}`}
			>
				<Feature>
					<Feature.Content>
						<ElaborationBudget
							identifiantSimulation={Number(identifiantSimulationRef.current)}
						/>
					</Feature.Content>
				</Feature>
			</Menu>
		</App>
	);
};
export default AppSimulation;
